import { useTranslation } from 'react-i18next';
import MotionDiv from '@/components/common/Motion/MotionDiv';

interface Props {
  className?: string;
}

const ExpensesEmptyState = ({ className = '' }: Props) => {
  const { t } = useTranslation();

  return (
    <MotionDiv delay={0.2}
      className={`relative flex flex-col bg-zinc-100 rounded-2xl px-4 py-5 flex items-center overflow-hidden ${className}`}>
      <p className="font-medium text-center text-base text-base-black w-[16.562rem] leading-[1.3] tracking-[0.01rem]">
        {t('expenses.emptyState')}
      </p>
    </MotionDiv>
  );
};

export default ExpensesEmptyState;
